export enum ELegalCheckInfoActions {
  setLegalCheckInfo = 'legalCheckInfo/setLegalCheckInfo',
}
